import { IconEye, IconX } from "@tabler/icons-react";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { SendTicket } from "../../../services/panel/ticket/ticketServices";
import { toast } from "react-toastify";
import { toastOptions } from "../../../features/toast/toast";
import { onError } from "../../../features/error/error";
import useGetData from "../../../hook/getData";
import { GetTickets } from "../../../services/panel/ticket/getTicket";
import { useState } from "react";
import { SendTicketMessage } from "../../../services/panel/ticket/sendTicketMessage";

const Ticket = () => {
    const { register, handleSubmit }: any = useForm<any>();
    const { register: registe_message, handleSubmit: handle_message }: any = useForm<any>();
    const { data: tickets, refetch } = useGetData(['tickets'], GetTickets)
    const [selectedTicket, setSelectedTicket] = useState<any>(null);
    const TicketMutation = useMutation({
        mutationFn: SendTicket,
        onSuccess: () => {
            toast.success('تیکت با موفقیت ثبت شد')
            refetch()
            document.getElementById('hide-ticket')?.click();
        },
        onError: (error: any) => {
            const errors: any = error.response.data?.message;
            if (errors) {
                for (const [, messages] of Object.entries(errors)) {
                    (messages as string[]).forEach((message) => {
                        toast.error(message, toastOptions);
                    });
                }
            }
        },
    });

    const TicketMutationMessage = useMutation({
        mutationFn: SendTicketMessage,
        onSuccess: () => {
            toast.success('پاسخ با موفقیت ثبت شد')
            refetch()
            document.getElementById('hide-ticket-message')?.click();
        },
        onError: (error: any) => {
            const errors: any = error.response.data?.message;
            if (errors) {
                for (const [, messages] of Object.entries(errors)) {
                    (messages as string[]).forEach((message) => {
                        toast.error(message, toastOptions);
                    });
                }
            }
        },
    });

    const onSubmit = (data: any) => {
        TicketMutation.mutate(data);
    }

    const onSubmit_ticket = (data: any) => {
        data.id = selectedTicket.id;
        TicketMutationMessage.mutate(data);
    }

    const handleViewTicket = (ticket: any) => {
        setSelectedTicket(ticket);
        document.getElementById('ticket-modal-message')?.classList.add('show');
        document.getElementById('ticket-modal-message')?.setAttribute('style', 'display: block;');
    };

    return (
        <>
            <div className="card card-body shadow border-1 rounded rounded-4">
                <div className="rounded box-site rounded-4 d-flex justify-content-between align-items-center py-3 mb-0">
                    <span>پشتیبانی</span>
                    <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#ticket-modal">
                        تیکت جدید
                    </button>
                </div>
                <div className="row mt-3">
                    <div className="col-12">
                        <div className="table-responsive mt-4">
                            <table className="table table-bordered text-center font-medium align-middle">
                                <thead>
                                    <tr>
                                        <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>ردیف</th>
                                        <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>تاریخ و ساعت</th>
                                        <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>موضوع</th>
                                        <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>اولویت</th>
                                        <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>وضعیت</th>
                                        <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>مشاهده و پاسخ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tickets?.tickets?.map((item: any, index: number) => (
                                        <tr key={index + 'ticket'}>
                                            <td>{index + 1}</td>
                                            <td>
                                                {item.created_at}
                                            </td>
                                            <td>
                                                {item.subject}
                                            </td>
                                            <td>
                                                {item.priority_fa}
                                            </td>
                                            <td>
                                                <button className="btn btn-outline-primary px-5"
                                                >
                                                    {item.status_fa}
                                                </button>
                                            </td>
                                            <td className="text-site">
                                                <IconEye
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleViewTicket(item)}
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#ticket-modal-message"
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="ticket-modal">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content p-3">
                        <div className="modal-header justify-content-between">
                            <h5 className="mb-0 fw-bold text-site">
                                افزودن تیکت
                            </h5>
                            <IconX data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(onSubmit, onError)}>
                                <div className="row mb-3 gy-3 mt-1">
                                    <div className="col-md-6">
                                        <fieldset className="form-floating">
                                            <input
                                                type="text"
                                                placeholder="موضوع"
                                                className="form-control"
                                                {...register("subject", { required: "فیلد موضوع الزامی است" })}
                                            />
                                            <label className="form-label">موضوع</label>
                                        </fieldset>
                                    </div>
                                    <div className="col-md-6">
                                        <fieldset className="form-floating">
                                            <select className="form-select"
                                                {...register("priority", { required: false })}
                                            >
                                                <option value="high">ضروری</option>
                                                <option value="medium">اولویت متوسط</option>
                                                <option value="low">عادی</option>
                                            </select>
                                            <label className="form-label">اولویت</label>
                                        </fieldset>
                                    </div>
                                    <div className="col-md-12">
                                        <fieldset className="form-floating">
                                            <textarea
                                                type="text"
                                                placeholder="message"
                                                className="form-control"
                                                {...register("message", { required: "فیلد توضیحات الزامی است" })}
                                            >
                                            </textarea>
                                            <label className="form-label">
                                                توضیحات
                                            </label>
                                        </fieldset>
                                    </div>
                                    <div>
                                        <button type="button" hidden id="hide-ticket" data-bs-dismiss="modal"></button>
                                        <button className="btn btn-primary py-2 px-5">
                                            ثبت
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="ticket-modal-message">
                <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
                    <div className="modal-content p-3">
                        <div className="modal-header justify-content-between">
                            <h5 className="mb-0 fw-bold text-site">
                                مشاهده و پاسخ
                            </h5>
                            <IconX data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            {selectedTicket?.messages?.length > 0 ? (
                                selectedTicket.messages
                                    .slice()   
                                    .reverse()
                                    .map((message: any, index: any) => (
                                        <div key={index} className={`my-4 card card-body border-0 shadow ${message.user_type === 'کاربر' ? ' me-5' : ' ms-5 border-3'}`}>
                                            <div className="d-flex justify-content-between mb-3 align-items-center">
                                                <p className="fw-bold mb-0">{message.user.name} {message.user.lastName}</p>
                                                <button className="btn btn-outline-primary px-5">
                                                    {message.user_type === 'کاربر' ? 'کاربر' : 'ادمین'}
                                                </button>
                                            </div>
                                            <p className="my-3">{message.message}</p>
                                            <div className="d-flex justify-content-end">
                                                <p className="mb-0 font-small-lg">{message.created_at}</p>
                                            </div>
                                        </div>
                                    ))
                            ) : (
                                <p>هیچ پیامی برای این تیکت وجود ندارد.</p>
                            )}
                        </div>
                        <div className="modal-footer w-100 px-0 px-4 ps-1">
                            <div className="row w-100 px-0 mt-4">
                                <div className="col-12">
                                    <form onSubmit={handle_message(onSubmit_ticket, onError)}>
                                        <fieldset className="form-floating">
                                            <textarea className="form-control" placeholder="پاسخ" style={{ height: '100px' }}
                                                {...registe_message("message", { required: false })}
                                            ></textarea>
                                            <label className="form-label">
                                                پاسخ
                                            </label>
                                        </fieldset>
                                        <div>
                                            <button type="button" hidden data-bs-dismiss="modal" id="hide-ticket-message"></button>
                                            <button className=" btn mt-4 btn-primary">
                                                ثبت پاسخ
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Ticket;